import {
	BUSINESS_UNIT_WEB_SDK_TABLE_ID,
	BUSINESS_UNIT_WFA_TABLE_ID
} from 'src/apps/dashboard/constants/Dashboard';

export const HEADER = {
	showLastUpdated: true
};

export const WEB_RESET_TABLE_IDS = [BUSINESS_UNIT_WFA_TABLE_ID, BUSINESS_UNIT_WEB_SDK_TABLE_ID];
